export let baseUrl =
  (document.getElementById("_baseUrl") as HTMLInputElement)?.value || "~";

if (baseUrl === "~") {
  const hostUrl = window.location.href.split("/");
  baseUrl = hostUrl[0] + "//" + hostUrl[2];
}
